class StorageConstructor {
  private readonly storage: Storage;

  private readonly isStorageAvailable: boolean;

  constructor(storage) {
    if (!storage) {
      throw new Error('Storage is not specified');
    }

    this.storage = storage;
    this.isStorageAvailable = this.getIsStorageAvailable();
  }

  /**
   * Tests and returns whether storage is available.
   *
   * @returns {Boolean}
   */
  getIsStorageAvailable() {
    try {
      const key = '___SCH_StorageTest___';
      const expectedValue = '123';

      this.storage.setItem(key, expectedValue);
      const value = this.storage.getItem(key);

      this.storage.removeItem(key);

      return value === expectedValue;
    } catch (error) {
      return false;
    }
  }

  /**
   * Returns value by given key.
   *
   * @param {String} key
   *
   * @returns {String}
   */
  get(key) {
    if (!this.isStorageAvailable) {
      return '';
    }

    return this.storage.getItem(key);
  }

  /**
   * Sets given value by given key.
   *
   * @param {String} key
   * @param {*} value
   *
   */
  set(key, value) {
    if (!this.isStorageAvailable) {
      // TODO: consider throwing error
      return false;
    }

    return this.storage.setItem(key, value);
  }

  /**
   * Removes given key from storage.
   *
   * @param {String} key
   */
  remove(key) {
    if (!this.isStorageAvailable) {
      // TODO: consider throwing error
      return false;
    }

    return this.storage.removeItem(key);
  }

  /**
   * Returns whether given key is exist in storage.
   *
   * @param {String} key
   *
   * @returns {Boolean}
   */
  has(key) {
    if (!this.isStorageAvailable) {
      return false;
    }

    return Object.prototype.hasOwnProperty.call(this.storage, key);
  }
}

export const LocalStorage = new StorageConstructor(window.localStorage);
export const SessionStorage = new StorageConstructor(window.sessionStorage);
